import React, { useEffect, useMemo, useState } from "react";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FooterComponent } from "../Footer";
import { Navbar } from "../Navigation/Navbar";
import {
  DatePicker,
  Layout,
  Select,
  Spin,
  Space,
  Button
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { HelpButton } from "../Common/HelpButton";
import dayjs from "dayjs";
import { CalendarViewV2 } from "./CalendarView/CalendarViewV2";
import "../../Styles/styles-OverviewV3.css";
import { Joyride, STATUS } from "react-joyride";
import { useSelector, useDispatch } from "react-redux";
import { 
  setFilter
} from "../../store/actions/dualcalendar.actions";
import {
  setFilter as setTrackerFiler
} from "../../store/actions/statustracker.actions";
import { setSubmitClicked } from "../../store/actions/dualcalendar.actions";
import { StatusTracker } from "../StatusTracker/StatusTracker";
import { useDataAccess, DataAccessDenied } from "@components/PermissionedComponents";
import { StatusTrackerV2 } from "../StatusTrackerV2";
import { getDatesToQuery } from "../StatusTrackerV2/state/utils";
import { buildFlagTypeOptions } from "../StatusTrackerV2/mappers/flags.mapper";
import { getAvailableStatuses } from "../../store/actions/statustracker.actions";
import { formattedPlayerName } from "../../Utils/name_utils";
import { getTeamDrillCostPerMin } from "../../store/actions/team.actions";

const { Footer } = Layout;

export const OverviewStatusTracker = (props) => {
  const dispatch = useDispatch();
  const {
    players,
    positions,
    playerGroups,
    info: { display_name: teamName, coach_list: coachList, acwr_threshold_config: acwrThresholdConfig, sessions },
  } = useSelector(({ team }) => team);
  const {
    currentUser: { email: currentUserEmail },
  } = useSelector(({ auth }) => auth);
  const { 
    submitClicked,
    filters: {
      playersFilter,
      positionsFilter,
      playerGroupsFilter,
      playerStatusesFilter,
      sessionsFilter,
      flagTypesFilter
    }
  } = useSelector(({ dualCalendar }) => dualCalendar);
  const [calendar1DateStrs, setCalendar1DateStrs] = useState(null);
  const [calendar2DateStrs, setCalendar2DateStrs] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [run, setRun] = useState(true);
  const {
    loading,
    trackerData,
    statuses,
  } = useSelector(({ statusTracker }) => statusTracker);
  const dateFormat = "MM/DD/YYYY";

  // The tracker below is V2 for a gated team and V1 for everyone else. Team info carries the
  // gate: true goes straight to V2, false straight to V1. It is undefined on an API that
  // predates the field, and that must not read as "off" — a gated team would lose V2 — so we
  // try V2 and let its 403 answer, which is what onUnavailable reports.
  const v2Gate = useSelector(({ team }) => team?.info?.status_tracker_v2_enabled);
  const [v2Failed, setV2Failed] = useState(false);
  const v2Unavailable = v2Gate === false || v2Failed;

  // V2 keeps its filters in its own context, so hand it the ones this page owns. Same key
  // names as the V1 slice these controls already dispatch into, so both trackers follow the
  // filter bar and the fallback needs no extra wiring.
  const trackerFilters = useSelector(({ statusTracker }) => statusTracker.filters);

  // Flags stage into the dual-calendar slice with the other filters, so both calendars pick
  // them up on Search. The V1 status tracker slice has no such key, so the applied value for
  // the V2 tracker is held here and set on Search, matching when the other filters reach it.
  const udfFlags = useSelector(({ userDefinedFlags }) => userDefinedFlags?.flags || []);
  const flagTypeOptions = useMemo(() => buildFlagTypeOptions(udfFlags), [udfFlags]);
  const [appliedFlagTypes, setAppliedFlagTypes] = useState([]);

  const v2Filters = useMemo(
    () => ({
      playersFilter: trackerFilters.playersFilter,
      positionsFilter: trackerFilters.positionsFilter,
      playerGroupsFilter: trackerFilters.playerGroupsFilter,
      playerStatusesFilter: trackerFilters.playerStatusesFilter,
      selectedMonth: trackerFilters.selectedMonth,
      flagTypesFilter: appliedFlagTypes,
    }),
    [trackerFilters, appliedFlagTypes]
  );

  // The Player Statuses dropdown above reads `statuses` off the V1 slice, which only the V1
  // tracker populates. V2 does not touch that slice, so fetch them here for the month on show.
  const trackerMonth = trackerFilters.selectedMonth;

  // Embedded mode has no filter bar, so the tracker's month picker sits at the head of its
  // status legend — where the V1 tracker put it. It writes to the same slice the other
  // controls here dispatch into, which externalFilters already carries into V2.
  const trackerMonthPicker = useMemo(
    () => (
      <div>
        <DatePicker
          value={trackerMonth}
          style={{ marginLeft: "10px" }}
          onChange={(date) => dispatch(setTrackerFiler({ selectedMonth: date }))}
          picker="month"
          allowClear={false}
          format={"MMM YYYY"}
        />
      </div>
    ),
    [trackerMonth, dispatch]
  );

  useEffect(() => {
    if (v2Unavailable || !trackerMonth) return;
    const dates = getDatesToQuery(trackerMonth);
    if (dates.length > 0) dispatch(getAvailableStatuses(dates[0], dates[dates.length - 1]));
  }, [v2Unavailable, trackerMonth, dispatch]);



  // const steps = useMemo(
  //   () => [
  //     {
  //       content: <h2>We introduced new functionalities, let's review them!</h2>,
  //       locale: { skip: <strong aria-label="skip">SKIP</strong> },
  //       placement: "center",
  //       target: ".outer-navbar",
  //     },
  //     {
  //       content:
  //         "Informational pop-ups have been incorporated throughout the “Overview” page to help explain various features, colors, metrics and symbols. If you require more information, please contact your GPS DataViz representative.",
  //       placement: "left",
  //       styles: {
  //         options: {
  //           width: 300,
  //         },
  //       },
  //       spotlightPadding: 5,
  //       disableScrolling: true,
  //       target: ".overall img",
  //     },
  //     {
  //       content:
  //         "Each box in the calendar now shows how close the session is to the next bucket above or below. If a session is green but nearing the threshold for yellow, the box is nearly completely full of green, with just a small gap at the top. If a session is yellow but barely higher than green, it shows just a little yellow at the bottom. This allows you to quickly differentiate between sessions that fall in the same colored bucket.",
  //       placement: "right",
  //       styles: {
  //         options: {
  //           width: 300,
  //         },
  //       },
  //       disableScrolling: true,
  //       target:
  //         ".calender>div:nth-child(2)>div>div>table>tbody>tr:nth-child(2)>td:nth-child(5)>div>div:nth-child(2)>button",
  //     },
  //     {
  //       content:
  //         "The first row of the ACWR section now shows the team’s ACWR in each key metric, allowing you to quickly assess the readiness of individual players as well as your team as a whole.  The acute number on the left represents your team’s daily average load in that metric over the last 7 days, also represented by the outside yellow dial. The chronic number on the right represents your team’s daily average load in that metric over the 21 days prior to the last 7 (days 28-8), also represented by the inside green dial.  The ACWR number in the middle is the ratio of your acute to chronic averages.",
  //       placement: "left",
  //       styles: {
  //         options: {
  //           width: 300,
  //         },
  //       },
  //       disableScrolling: true,
  //       target: ".acwr-table>div>div>div>div>div>table>tbody>tr:nth-child(1)",
  //     },
  //     {
  //       content:
  //         "The new toggle above the ACWR section allows you to use this section to see your players’ cumulative weekly load in each of their key metrics.  This allows you to better gauge the readiness of your athletes and plan practice sessions around your upcoming games, ensuring athletes reach/don’t exceed certain key thresholds.  The weekly total is currently set as 2.5x your team baseline in that metric, and you will soon be able to adjust this multiple if you choose to.",
  //       placement: "bottom",
  //       styles: {
  //         options: {
  //           width: 300,
  //         },
  //       },
  //       disableScrolling: true,
  //       target: ".weekly_toggle_class",
  //     },
  //     {
  //       content: (
  //         <div>
  //           <p>
  //             The new tiles below your calendar allow you to easily compare
  //             current metrics to prior metrics. This applies to all metrics your
  //             team is currently tracking. The toggle and date bar above the
  //             tiles dictate the changes shown. The date bar defaults to today,
  //             but you can compare for any prior day and view how loads compared.
  //             The toggle allows you to compare different time periods:
  //           </p>
  //           <ol>
  //             <li>TODAY- Compares today to same day of the week last week</li>
  //             <li>
  //               WEEK- Compare the week so far to same days last week (if today
  //               is Thursday, comparing the cumulative totals from
  //               Monday-Thursday this week to Monday-Thursday last week)
  //             </li>
  //             <li>
  //               7 DAYS- Compare the last 7 days cumulative loads to the prior 7
  //               days cumulative loads
  //             </li>
  //             <li>
  //               MONTH- Compare the month so far to last month same period (if
  //               today is the 23rd, comparing the cumulative loads from days 1-23
  //               this month to days 1-23 last month)
  //             </li>
  //             {/* <li>GAME DAY- Compare today’s training or game to the last training or game that matches (if today is GameDay -2 it will compare to your prior GameDay -2)</li> */}
  //           </ol>
  //         </div>
  //       ),
  //       placement: "bottom",
  //       styles: {
  //         options: {
  //           width: 600,
  //         },
  //       },
  //       target: ".metric_dropdown_tiles",
  //     },
  //   ],
  //   []
  // );
  // const trainingAPI = useMemo(() => new TrainingAPI(), []);

  const { canAccess, ready: permissionsReady, isDenied: isDataDenied } = useDataAccess();

  useEffect(() => {
    // Drill cost per minute is GPS-derived; the endpoint 403s without access.
    if (!permissionsReady || !canAccess("gps")) return;
    dispatch(getTeamDrillCostPerMin());
  }, [permissionsReady]);


  const handleJoyrideCallback = (data) => {
    const { status, type } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      localStorage.setItem("feature_intro", false);
      setRun(false);
    }
  };

  const onMonthChange = (curr_date, dateString) => {
    const { player_ids, positions, player_groups } = getFilters();
    dispatch(setFilter({ selectedMonth: curr_date }));
    dispatch(setTrackerFiler({ selectedMonth: curr_date }));
    
    // --- Calendar 1 (Last Month) ---
    const last_month_date = curr_date.clone().subtract(1, 'month'); 
    const calendar1Start = last_month_date.clone().startOf('month');
    const calendar1End = last_month_date.clone().endOf('month');
    let dates = [];
    let current = calendar1Start.clone();
    while (current.isSameOrBefore(calendar1End, 'day')) {
      dates.push(current.format('YYYY-MM-DD'));
      current = current.add(1, 'day');
    }
    setCalendar1DateStrs(dates);

    // --- Calendar 2 (Current Month) ---
    dates = []
    const calendar2Start = curr_date.clone().startOf('month');
    const calendar2End = curr_date.clone().endOf('month');
    current = calendar2Start.clone();
    while (current.isSameOrBefore(calendar2End, 'day')) {
      dates.push(current.format('YYYY-MM-DD'));
      current = current.add(1, 'day');
    }
    setCalendar2DateStrs(dates);
  }

  const onChangePlayer = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ playersFilter: value }));
  };

  const onChangePosition = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ positionsFilter: value }));
  };

  const setSelectedPlayerGroups = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ playerGroupsFilter: value }));
  };

  const setSelectedPlayerStatuses = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ playerStatusesFilter: value }));
  };

  const setSelectedFlagTypes = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ flagTypesFilter: value }));
  };

  const setSelectedSessions = (value) => {
    setExpanded(!expanded);
    dispatch(setFilter({ sessionsFilter: value }));
  };

  const getFilters = () => {
    let player_ids = [];
    let filteredStatusPlayerIds = new Set();
    if (playerStatusesFilter.length > 0) {
      if (playersFilter.length > 0) {
        const uKeys = new Set();
        for (let i = 0; i < playersFilter.length; i++) {
          for (let j = 0; j < calendar2DateStrs.length; j++) {
            uKeys.add(`${playersFilter[i]}_${calendar2DateStrs[j]}`)
          }
        }
        const filteredDS = Object.fromEntries(
          Object.entries(trackerData).filter(([ukey, data]) => uKeys.has(ukey))
        );
        for(const [uKey, data] of Object.entries(filteredDS)){
          const playerId = data.player_id;
          if (
            data.status && 
            playerStatusesFilter.includes(data.status.status_id || data.status.id) && 
            !filteredStatusPlayerIds.has(playerId)
          ) {
            filteredStatusPlayerIds.add(playerId);
          } 
        }
      } else {
        
      }
      player_ids = Array.from(filteredStatusPlayerIds);
    } else {
      player_ids = playersFilter;
    }
  
    return { player_ids, positions: positionsFilter, player_groups: playerGroupsFilter };
  }

  const handleSubmit = () => {
    if (!submitClicked) {
      dispatch(setSubmitClicked(true));
    }
    setAppliedFlagTypes(flagTypesFilter);
    dispatch(setTrackerFiler({ 
      playersFilter: playersFilter, 
      playerStatusesFilter: playerStatusesFilter, 
      positionsFilter: positionsFilter, 
      playerGroupsFilter: playerGroupsFilter,
      sessionsFilter: sessionsFilter
    }));
  }

  return (
    <>
      {/* <Joyride
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        run={run}
        scrollToFirstStep
        showSkipButton
        steps={steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      /> */}
      <Navbar />
      <HelpButton page="Overview"/>

      <div className="overview-tracker-filter-container">
        <div>
          <Select
            allowClear
            showSearch
            style={{ width: "100%" }}
            placeholder="Choose Players"
            value={playersFilter}
            onChange={onChangePlayer}
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            mode="multiple"
            maxTagCount={1}
            options={players ? players.map((player, i) => ({
              key: i,
              value: player.player_id,
              label: `${formattedPlayerName(teamName, player.first_name + " " + player.last_name)} #${player.number}`,
            })) : []}
          />
        </div>
        <div>
          <Select
            allowClear
            showSearch
            style={{ width: "100%" }}
            placeholder="Choose Positions"
            value={positionsFilter}
            onChange={onChangePosition}
            filterOption={(input, option) =>
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            mode="multiple"
            maxTagCount={2}
            options={positions ? positions.map((pos, i) => ({ key: i, value: pos, label: pos })) : []}
          />
        </div>
        <div>
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Choose Player Groups"
            value={playerGroupsFilter}
            style={{ width: "100%" }}
            onChange={setSelectedPlayerGroups}
            mode="multiple"
            maxTagCount={1}
            options={playerGroups.map((playerGroup, i) => ({
              key: i,
              value: playerGroup?.player_group_id,
              label: playerGroup?.name,
            }))}
          />
        </div>
        <div>
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Choose Player Statuses"
            value={playerStatusesFilter}
            style={{ width: "100%" }}
            onChange={setSelectedPlayerStatuses}
            mode="multiple"
            maxTagCount={2}
            options={statuses.map((status, i) => ({
              key: i,
              value: status?.id,
              label: status?.name,
            }))}
          />
        </div>
        <div>
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Choose Sessions"
            value={sessionsFilter}
            style={{ width: "100%" }}
            onChange={setSelectedSessions}
            mode="multiple"
            maxTagCount={2}
            options={sessions?.map((session, i) => ({ key: i, value: session, label: session })) ?? []}
          />
        </div>
        {!v2Unavailable && (
          <div>
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="Choose Flags"
              value={flagTypesFilter}
              style={{ width: "100%" }}
              onChange={setSelectedFlagTypes}
              mode="multiple"
              maxTagCount={2}
              options={flagTypeOptions}
            />
          </div>
        )}
        <div className="ost-submit-btn">
          <Button type="primary" onClick={handleSubmit}>
            Search
          </Button>
        </div>
      </div>
      <div className="dual-calendar">
        {/* Held back until permissions resolve: CalendarViewV2 fetches /calendar/month
            on mount, and that endpoint 403s without AccessGpsData. Rendering on
            `isDataDenied` alone would mount it during the not-yet-known window — the
            request would fire and fail before the denial replaced it. */}
        {!permissionsReady ? null : isDataDenied("gps") ? (
          // The calendars are entirely GPS-derived, so each is replaced by its own
          // box in place. The status tracker below still works — it also carries
          // flags, injuries and statuses — it just renders without its ACWR dots.
          <Space size={"large"} className="dual-calendar-denied-row">
            <DataAccessDenied streams={["gps"]} variant="inline" className="dual-calendar-denied" />
            <DataAccessDenied streams={["gps"]} variant="inline" className="dual-calendar-denied" />
          </Space>
        ) : (
          <Space size={"large"}>
            <CalendarViewV2 calendarId={1} />
            <CalendarViewV2 calendarId={2} />
          </Space>
        )}
      </div>
      {v2Unavailable ? (
        <StatusTracker
          isEmbedded={true}
        />
      ) : (
        <StatusTrackerV2
          isEmbedded={true}
          externalFilters={v2Filters}
          onUnavailable={() => setV2Failed(true)}
          legendLeading={trackerMonthPicker}
        />
      )}
      <FooterComponent/>
    </>
  );
};